import { render, staticRenderFns } from "./EditarStock.vue?vue&type=template&id=69c87c2a&"
import script from "./EditarStock.vue?vue&type=script&lang=js&"
export * from "./EditarStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports